import Router from './Components/Assets/Router';
import "./Components/Assets/Css/bootstrap.min.css"
import "./Components/Assets/Css/icons.min.css"
import "./Components/Assets/Css/app.min.css"
import "./Components/Assets/Css/custom.css"
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-tooltip/dist/react-tooltip.css';


function App() {
  console.log = () => { }
  console.error = () => { }
  console.debug = () => { }
  return (
    <div className="App">
      <Router />
      <ToastContainer />
    </div>
  );
}

export default App;
